import { createApi, createEffect, createStore, sample } from 'effector';

import { SK } from 'fp-ts/lib/function';

import { getToplineVisibilityFx } from '@stores/topline';

const STORAGE_KEY = 'telegram_promo_closed';

const HIDE_FOR_DAYS = 14;

type ToplineState = {
    isOpen: boolean;
};

const defaultValue = {
    isOpen: false,
};

export const getTelegramPromoVisibilityFx = createEffect<void, ToplineState>(async () => {
    const closedTimestamp = localStorage.getItem(STORAGE_KEY);
    if (closedTimestamp) {
        const daysPassed = (Date.now() - parseInt(closedTimestamp, 10)) / (1000 * 60 * 60 * 24);
        if (daysPassed < HIDE_FOR_DAYS) {
            return { isOpen: false };
        } else {
            localStorage.removeItem(STORAGE_KEY);
            return { isOpen: true };
        }
    }
    return { isOpen: true };
});

export const $isTelegramPromoVisible = createStore<ToplineState>(defaultValue).on(
    getTelegramPromoVisibilityFx.doneData,
    SK,
);

export const $isTelegramPromoVisibleApi = createApi($isTelegramPromoVisible, {
    close: () => {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
        return {
            isOpen: false,
        };
    },
});

sample({
    clock: getToplineVisibilityFx.doneData,
    target: getTelegramPromoVisibilityFx,
    filter: (toplineState) => !toplineState.isOpen,
});
